import React, { useState, useCallback} from 'react';

import { Input, MaterialIcon } from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { dispatch, getState } from 'pluginServices/store';
import debounce from 'lodash/debounce';

import messages from './messages';
import { setPublicationsSearch } from '../../store/actions';
import {
  SearchContainer,
  SearchClearButton,
} from './styles';

const PublicationSearch = () => {
  const state = getState();
  const [filterValue, setFilterValue] = useState(state.getIn(['workspacePublications', 'publicationsSearch']) || '');

  const searchPublicationTitles = useCallback(
    debounce(async (value) => {
      dispatch(setPublicationsSearch(value));
    }, 500), []
  );

  const handleSearchInput = (event) => {
    setFilterValue(event.target.value);
    searchPublicationTitles(event.target.value);
  };

  const setDefault = () => {
    setFilterValue('');
    dispatch(setPublicationsSearch(''));
  };

  return (
    <SearchContainer>
      <Input.Search
        width={'50%'}
        value={filterValue}
        onChange={(e) => handleSearchInput(e)}
        placeholder={intl.formatMessage(messages.search)}
        label={intl.formatMessage(messages.search)}
        data-testid="inputSearch"
      />
      {filterValue &&
        <SearchClearButton
          grey
          rounded
          onClick={() => setDefault()}
          data-testid="clearButton"
        >
          <MaterialIcon id="close" />
        </SearchClearButton>
      }
    </SearchContainer>
  );
};

export default PublicationSearch;
